import { render, staticRenderFns } from "./EmbeddedNewQuotedDocumentEditView.vue?vue&type=template&id=5d32a68a&scoped=true&"
import script from "./EmbeddedNewQuotedDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedNewQuotedDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedNewQuotedDocumentEditView.vue?vue&type=style&index=0&id=5d32a68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32a68a",
  null
  
)

export default component.exports